<template>
  <div class="slider-opacity">
    <el-slider class="so-slider" v-model="opacity" :show-tooltip="false" @change="onOpacityChange"></el-slider>
    <span class="opacity-ipt">
      <el-input-number class="c-num-input" controls-position="right" :max="100" :min="0" size="small"
                           v-model="opacity" @change="onOpacityChange"></el-input-number></span>
  </div>
</template>
<script>
    export default {
        props:{
            value: Number
        },
        data() {
            return {
                opacity: 100
            };
        },
        watch:{
            value(v){
                let val = parseInt(v);
                if(val !== this.opacity){
                    this.init();
                }
            }
        },
        created(){
            this.init();
        },
        methods: {
            init(){
                this.opacity = parseInt(+this.value * 100);
            },
            formatterOpacityTip(val) {
                return `${val}%`
            },
            onOpacityChange(v) {
                let opacity = parseFloat((v / 100).toFixed(2));
                this.$emit('input', opacity);
                this.$emit('onChange', opacity);
            },
        }
    }
</script>
<style lang="scss">
  @import "opacity-index";
</style>